import { type KPIScoreLimit, Score } from 'components/KPICard'

export const RESPONSE_RATE_RANGE_DESCRIPTION = `Needs work = less than 70%
Fair = 70% - 79%
Good = 80% - 89%
Excellent = 90% - 100%`

export const KPI_SCORES: KPIScoreLimit[] = [
  { max: 70, score: Score.NeedsWork },
  { max: 79, score: Score.Fair },
  { max: 89, score: Score.Good },
  { max: 100, score: Score.Excellent },
]
